import { SelectCardGroup } from '@domains/billing-settings/priv/CardGroup/usecases/SelectCardGroup'
import { createCustomTheme } from '@domains/subscription/theme'
import { ThemeProvider } from '@mui/material'
import useMaterialNotification from 'hooks/useMaterialNotification'
import type { CardGroup } from '../api/api'
import { useCardGroup, useRemoveCardGroupOverride, useSetCardGroupOverride } from '../api/queries'

interface SelectCardGroupFactoryProps {
  customerId: string
}

export const SelectCardGroupFactory = ({ customerId }: SelectCardGroupFactoryProps) => {
  const { data: cardGroupData, isLoading, isFetching, isError } = useCardGroup(customerId)
  const { mutate: removeOverride, isLoading: isDeleting } = useRemoveCardGroupOverride(customerId)
  const { mutate: setOverride, isLoading: isPatching } = useSetCardGroupOverride(customerId)

  const notify = useMaterialNotification()

  const handleSelectCardGroup = (group: CardGroup) => {
    setOverride(group, {
      onSuccess: () => {
        notify('Card group override set')
      },
    })
  }

  const handleRemoveOverride = () => {
    removeOverride(undefined, {
      onSuccess: () => {
        notify('Card group override removed')
      },
    })
  }

  return (
    <ThemeProvider theme={createCustomTheme()}>
      <SelectCardGroup
        group={cardGroupData?.group}
        isOverridden={cardGroupData?.isOverridden ?? false}
        onSelectCardGroup={handleSelectCardGroup}
        onRemoveOverride={handleRemoveOverride}
        isDeleting={isDeleting || isFetching}
        isLoading={isLoading}
        isPatching={isPatching || isFetching}
        isError={isError}
      />
    </ThemeProvider>
  )
}
